import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { MainContent, PageHeading } from '../../../components/Shell/Content';
import LoadingSkeleton from '../../../components/Shell/LoadingSkeleton';

import useAsync from '../../../hooks/useAsync';
import { getIntegration } from '../../../api/company';

import Devices from './custom/LarianTech/Devices';
import { classNames } from '../../../components/helpers/functions';
import Configure from './Configure';

const Integration = () => {
	const { id, tab } = useParams();
	const navigate = useNavigate();

	const {
		value: integration,
		status: loadingIntegration,
		execute: onRefreshIntegration,
	} = useAsync(getIntegration, { defaultPayload: { id } });

	const orgIntegration = integration?.organizations?.length
		? integration?.organizations[0]?.organization_integration
		: null;

	const isActive = !!orgIntegration;

	const AVAILABLE_TABS = {
		devices: {
			name: 'Devices',
			key: 'devices',
			current: (isActive && !tab) || tab === 'devices',
			onClick: () => {
				navigate(`/settings/integrations/${id}/devices`);
			},
			component: () => (
				<Devices integration={integration} onRefresh={onRefreshIntegration} />
			),
		},
		overview: {
			name: 'Overview',
			key: 'overview',
			current: tab === 'overview',
			onClick: () => navigate(`/settings/integrations/${id}/overview`),
			component: () => <div>Overview</div>,
		},
		configure: {
			name: 'Configure',
			key: 'configure',
			current: (!isActive && !tab) || tab === 'configure',
			onClick: () => navigate(`/settings/integrations/${id}/configure`),
			component: () => (
				<Configure integration={integration} onRefresh={onRefreshIntegration} />
			),
		},
	};

	const INTEGRATION_CONFIG = {
		'larian-tech': {
			tabs: [...(isActive ? ['devices'] : []), 'configure'],
		},
	}[integration?.key];

	const TABS =
		INTEGRATION_CONFIG?.tabs?.map((key) => AVAILABLE_TABS[key]) || [];

	const currentTab = AVAILABLE_TABS[tab];

	if (loadingIntegration === 'pending') {
		return (
			<MainContent>
				<LoadingSkeleton />
			</MainContent>
		);
	}

	console.log('INTEGRATION_CONFIG.tabs: ', INTEGRATION_CONFIG, TABS);

	return (
		<MainContent maxWidth="w-full">
			<PageHeading
				divider={false}
				onBack={() => navigate(`/settings/integrations`)}
			>{`Integration: ${integration?.name}`}</PageHeading>

			{INTEGRATION_CONFIG ? (
				<>
					<div className="border-b border-gray-200">
						<div className="sm:flex sm:items-baseline">
							<div className="mt-4 sm:mt-0">
								<nav className="-mb-px flex space-x-8">
									{TABS?.map((tab) => {
										return (
											<a
												key={tab?.name}
												onClick={() =>
													typeof tab.onClick === 'function'
														? tab.onClick()
														: null
												}
												className={classNames(
													tab.current
														? 'border-indigo-500 text-indigo-600'
														: 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
													'whitespace-nowrap border-b-2 px-1 pb-4 text-sm font-medium cursor-pointer',
												)}
												aria-current={tab.current ? 'page' : undefined}
											>
												{tab.name}
											</a>
										);
									})}
								</nav>
							</div>
						</div>
					</div>

					<div className="my-4">
						{AVAILABLE_TABS[
							isActive ? (tab ? tab : INTEGRATION_CONFIG.tabs[0]) : 'configure'
						]?.component()}
					</div>
				</>
			) : (
				<div className="flex">Error: Integration not found</div>
			)}

			{/*<Tabs
				tabs={[
					{ name: 'Devices', key: 'devices', disabled: !isActive },
					{ name: 'Configure', key: 'config' },
					//{ name: 'Components', key: 'components' },
				]}
				initialTab={isActive ? 'devices' : 'config'}
			>
				{(activeTab) => {
					if (activeTab === 'config') {
						return (
							
						);
					} else if (activeTab === 'components') {
						return (
							<div className="text-xs">
								This integration does not have any components
							</div>
						);
					} else if (activeTab === 'devices') {
						return (
							<Devices id={id} apiUrl={`${integration?.apiUrl}/devices`} />
						);
					}
				}}
			</Tabs>*/}
		</MainContent>
	);
};

export default Integration;
